import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SpanTooltipComponent } from "../../../shared/components/span-tooltip/span-tooltip.component";
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { CustomizeFieldsComponent } from "../customize-fields/customize-fields.component";
import { AutoFocusModule } from 'primeng/autofocus';

@Component({
    selector: 'customize-fields-modal',
    templateUrl: './customize-fields-modal.component.html',
    standalone: true,
    imports: [
      FormsModule,
      NgClass,
      AfTranslateDirective,
      SpanTooltipComponent,
      CustomizeFieldsComponent,
      AutoFocusModule
    ]
})
export class CustomizeFieldsModalComponent implements OnInit {
  configuration: any = this.dialogConfig.data;
  customizeField: any = {
    field: this.configuration.field
  }
  constructor(private dialogRef: DynamicDialogRef<CustomizeFieldsModalComponent>,
    private dialogConfig: DynamicDialogConfig) { }
  @ViewChild(CustomizeFieldsComponent) customizeFields: CustomizeFieldsComponent;

  ngOnInit(): void {
    setTimeout(()=> {
      this.customizeField.field.editableName = true;
    });
  }

  changeEditableField(field: any, e: any){
    if(!field.label){
      let input: any = $('#field-modal-' + field.id);
      input.focus().select();
      field.error = true;
    }else{
      field.editableName = false;
    }
  }

  checkErrorLabel(field: any){
    field.error = field.label?.length?false:field.error;
  }

  saveField(){
    this.customizeFields.saveField();
  }

  deleteField(){
    this.customizeFields.launchFieldAction('delete', 'modal');
  }

  emitAction(e: any){
    if(this.configuration.concept.templatesConcept?.length){
      this.configuration.concept.templatesConcept.forEach((template: any) => {
        delete template.selected;
      });
    }
    if(e?.action === 'saved'){
      this.handleAccept(e.field);
    }else{
      this.handleDismiss();
    }
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }

  handleAccept(field: any) {
    this.dialogRef.close({
        result: 'ok',
        field: field
    })
  }
}
